import { Output, EventEmitter, Input, OnInit, Component } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { OrientationService } from "../../../../../phf.service";


@Component({
    selector: 'orientation-eol-window',
    templateUrl: './orientation-eol.component.html',
    styleUrls: ['../../part-detail.component.scss']
})

export class OrientationEOLDialog implements OnInit {
    orientationEOLEditForm: FormGroup;
    part: any;
    public opened: boolean

    @Input()
    set data(editForm: FormGroup) {
        if (editForm) {
            this.part = editForm.value;
        }
    }

    @Output()
    save: EventEmitter<any> = new EventEmitter();
    @Output()
    close: EventEmitter<any> = new EventEmitter();

    constructor(
        private readonly formBuilder: FormBuilder,
        public readonly orientationService: OrientationService,
    ) {
        this.orientationService.read();
    }

    ngOnInit() {
        this.orientationEOLEditForm = this.formBuilder.group(OrientationEOLForm);
        this.orientationEOLEditForm.reset(this.part);
    }

    closeWindow() {
        this.close.emit();
        this.opened = false;
    }

    // Builds and passes OrientationNote value to the FirstOrientation editForm in PartLoading tab
    onSave() {
        this.save.emit(this.orientationEOLEditForm.get('OrientationOnEOL').value);
    }

    onClicked = (dataItem, orientation) => {
        const orientationDescription = this.orientationService.value.find(x => x.Id === dataItem);
        const description = (orientationDescription ? ` ${orientationDescription.Description}` : '') + ` ${orientation},`;
        if (this.orientationEOLEditForm.get("OrientationOnEOL").value) {
            const orientationNote = this.orientationEOLEditForm.get("OrientationOnEOL").value.concat(description);
            this.orientationEOLEditForm.get("OrientationOnEOL").setValue(orientationNote);
        } else {
            this.orientationEOLEditForm.get("OrientationOnEOL").setValue((orientationDescription ? orientationDescription.Description : '') + ` ${orientation},`);
        }
    }
}

const OrientationEOLForm = {
    OrientationOnEOL: []
}


